// Learndash courses page filter
// This function will find the checkbox fields and creates an equivalent dropdown
jQuery(document).ready(function($) {

    // find Learndash elements
    const taxonomyWrapper = $('.taxonomy.ld_course_category');
    const submitButtons = $('.learndash-course-grid-filter .filter-wrapper .buttons');
    
    // only continue if taxonomyWrapper exists
    if (taxonomyWrapper.length) {

        // find checkboxItems
        const checkboxItems = taxonomyWrapper.find('li.term');
        
        // new DOM element as a string
        const selectHtml = '<select id="ld-course-category-dropdown"><option value="">Select course category</option></select><button id="ld-course-category-reset">Clear selection</button>';

        // create <select> DOM element from string
        const select = $.parseHTML( selectHtml );

        // Hide Buttons
        submitButtons.hide();

        // Hide the checkbox list (not remove!)
        taxonomyWrapper.find('ul.terms').hide();

        // Append the <select>
        taxonomyWrapper.append(select);

        // get the select element as jQuery object
        const selectElement = $('#ld-course-category-dropdown');

        // loop over checkboxItems
        checkboxItems.each(function () {

            // find checkbox input field
            const input = $(this).find('input[type="checkbox"]');

            // get checkbox input label
            const labelText = $.trim($(this).text());

            // get checkbox input value
            const value = input.val();

            // new <option> DOM element as a string
            const optionHtml = `<option value="${value}">${labelText}</option>`;
            
            // create option DOM element from string
            const option = $.parseHTML( optionHtml );

            // append <option> element to <select> element
            selectElement.append( option );

        });

        // On <select> change, check the matching box and click the Apply button
        selectElement.on('change', function () {

            // add active class, used for tracking the re-initialisation of buttons
            $(this).addClass('loading');

            taxonomyWrapper.find('input[type="checkbox"]').prop('checked', false);

            const selectedValue = $(this).val();
            if (selectedValue) {
                taxonomyWrapper.find(`input[type="checkbox"][value="${selectedValue}"]`).prop('checked', true);
            }

            // Trigger the Apply button's click instead of submitting the form
            $('.filter-wrapper .buttons .apply').trigger('click');

        });

        $('#ld-course-category-reset').on('click', function(e){

            e.preventDefault();

            selectElement.prop('selectedIndex', 0);
            selectElement.trigger('change');

        });
    }

    $url = window.location.href;
    $('.ld-lesson-list .ld-item-name').each(function(){
        if($(this).attr('href') == $url){
            $(this).parent().parent().addClass('current-link');
        }
    });

    toggleOpenLessonSelectorOnMobile();
    sentanceCaseLearndashButtons();
});


function toggleOpenLessonSelectorOnMobile () {
    const titleButton = document.querySelectorAll('.learndash-course-sidebar-title')[0];
    const lessonList = document.querySelectorAll('.learndash-sticky-content .learndash-wrapper')[0];

    if (!titleButton) return;
    titleButton.addEventListener('click', function() {
        lessonList.classList.toggle('show-lessons');
        titleButton.classList.toggle('show-lessons')
    });

}


//Sentance case learndash buttons
function sentanceCaseLearndashButtons () {
    let buttons = document.querySelectorAll('.wpProQuiz_button');

    buttons.forEach(button => {
        let text = button.value.trim();

        if (text.length > 0) {
            text = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            if (text == 'View questions') {
                text = 'View results'
            }
            button.value = text;

        }
    });
}


//add a button on the courses archive page
document.addEventListener('DOMContentLoaded', function () {

    // function to add custom Learndash buttons
    function addCustomLearndashButtons() {

        document.querySelectorAll('.item > .post').forEach(course => {

        const link = course.querySelector('a');
        if (!link) return;

        const btn = document.createElement('a');
        btn.href = link.href;
        btn.className = 'wp-block-button__link ld_signedin_grid_btn';

        // Check enrollment status
        let courseStatus = course.querySelector('.thumbnail .ribbon').textContent.trim();

        if (courseStatus == 'Enrolled') {
            btn.textContent = 'Continue course';
        } else if (courseStatus == 'Completed') {
            btn.textContent = 'View course';
        } else {
            btn.textContent = 'Enroll on course';
        }
         

        course.appendChild(btn);
        });

        // Author name formatting
        document.querySelectorAll('span').forEach(span => {
        if (!span.classList.contains('privacy-policy-register') && span.textContent.trim().startsWith('By ')) {
          const name = span.textContent.trim().replace(/^By\s*/, '');
          span.innerHTML = `By: <strong class="author-name">${name}</strong>`;
        }
        });

    }
    // trigger on page load
    addCustomLearndashButtons();

    // Learndash uses the "fetch" function, so we monitor all "fetch" requests
    // and only continue if we find the relevant Learndash one
    const originalFetch = window.fetch;
    window.fetch = function() {
        return originalFetch.apply(this, arguments).then(function(response) {

            // only trigger if the action "ld_cg_load_more" or "ld_cg_apply_filter" is used
            if ( response.url.includes('action=ld_cg_load_more') ) {
                // update buttons after the DOM has had time to update
                // in this case, setTimeout is necessary
                setTimeout(function() {
                    addCustomLearndashButtons();
                }, 500);
            }   

            // trigger if ('#ld-course-category-dropdown') has .loading class
            // this means a filter was clicked
            if( response.url.includes('wp-admin/admin-ajax.php') && jQuery('#ld-course-category-dropdown').length > 0 && jQuery('#ld-course-category-dropdown').hasClass('loading') ) {

                // update buttons after the DOM has had time to update
                // in this case, setTimeout is necessary
                setTimeout(function() {
                    addCustomLearndashButtons();
                }, 500);

                // remove loading class
                jQuery('#ld-course-category-dropdown').removeClass('loading');

            }

            return response;
        });
    };

});
